import type { App } from 'vue';

declare global {
    interface Window {
        chrome?: typeof chrome;
    }
}

export default {
    install(app: App) {
        const extensionIds: Record<string, string> = {
            sbkDialer: 'pfilblgjdmmakankpdocpfefhfphgeen',
            sbkDialerPreprod: 'cigabmdoemjmcicgldgjmcgoppnggadl',
        };

        const chromeExtensions: string[] = [];

        function sbkDialerExtensionExist() {
            try {
                chrome.runtime.sendMessage(
                    extensionIds.sbkDialer,
                    {
                        action: 'getVersion',
                    },
                    (response) => {
                        if (response) {
                            chromeExtensions.push('sbkDialer');
                        } else {
                            chrome.runtime.sendMessage(
                                extensionIds.sbkDialerPreprod,
                                {
                                    action: 'getVersion',
                                },
                                (response) => {
                                    if (response) {
                                        chromeExtensions.push('sbkDialer');
                                    }
                                }
                            );
                        }
                    }
                );
            } catch (error) {
                // no code needed
            }
        }

        sbkDialerExtensionExist();

        app.config.globalProperties.$chromeExtensions = chromeExtensions;
    },
};
